import { ref, watch } from '@vue/composition-api'
import store from '@/store'

export default function controller() {
  const blankItem = {
    id: null,
    name: null,
    display_name: null,
    color: null,
    status_type: null,
  }
  const form = ref(null)
  const items = ref([])
  const item = ref({})
  const tableColumns = [
    { text: 'Nom', value: 'name' },
    { text: 'Type', value: 'status_type' },
    { text: 'Status', value: 'status' },
    {
      text: 'Actions',
      value: 'actions',
      align: 'center',
      sortable: false,
    },
  ]
  const isSnackbarBottomVisible = ref(false)
  const snackBarMessage = ref('')
  const isFormActive = ref(false)
  const searchQuery = ref('')
  const selectedStatus = ref('')
  const totalItems = ref(0)
  const loading = ref(false)
  const options = ref({
    rowsPerPage: 10,
    page: 1,
    sortDesc: [true],
  })
  const page = ref(1)
  const pageCount = ref(0)
  const selectedRows = ref([])
  const selectedItem = ref([])
  const resetForm = () => {
    if (form.value) form.value.reset()
  }

  // new item
  const openDialog = val => {
    if (val) {
      item.value = val
    } else {
      item.value = JSON.parse(JSON.stringify(blankItem))
      resetForm()
    }
    isFormActive.value = !isFormActive.value
  }

  const getChipColor = status => {
    if (status == 0) return 'warning'
    if (status == 1) return 'success'

    return 'primary'
  }

  // eslint-disable-next-line consistent-return
  const getStatus = status => {
    if (status == 1) {
      return 'Activé'
    }
    if (status == 0) {
      return 'Désactivé'
    }
  }

  // fetch data
  const fetchItems = () => {
    isFormActive.value = false
    store
      .dispatch('status/fetchItems', {
        term: searchQuery.value,
        type: selectedItem.value,
        status: selectedStatus.value,
        orderBy: options.value.sortBy ? options.value.sortBy[0] : 'id',
        // eslint-disable-next-line no-nested-ternary
        direction: options.value.sortDesc ? (options.value.sortDesc[0] ? 'DESC' : 'ASC') : 'DESC',
        page: options.value.page,
        per_page: options.value.itemsPerPage,
      })
      .then(response => {
        const { data, total } = response.data

        items.value = data
        totalItems.value = total

        // remove loading state
        loading.value = false
      })
      .catch(error => {
        console.log(error)
      })
      .then(() => {
        loading.value = false
      })
  }
  const deleteItem = val => {
    if (val) {
      store.dispatch('status/deleteItem', val.id)
        .then(response => {
          fetchItems()
          // eslint-disable-next-line no-unused-vars
        }).catch(error => {

        })
    }
  }

  watch([searchQuery, options], () => {
    loading.value = true
    selectedRows.value = []
    fetchItems()
  })

  watch([selectedItem, options], () => {
    loading.value = true
    selectedRows.value = []
    fetchItems()
  })

  watch([selectedStatus, options], () => {
    loading.value = true
    selectedRows.value = []
    fetchItems()
  })

  return {
    item,
    items,
    tableColumns,
    searchQuery,
    selectedStatus,
    getChipColor,
    getStatus,
    totalItems,
    loading,
    options,
    selectedRows,
    selectedItem,
    isFormActive,
    blankItem,
    form,
    page,
    pageCount,
    snackBarMessage,
    isSnackbarBottomVisible,
    resetForm,
    openDialog,
    deleteItem,
    fetchItems,
  }
}
